import { fieldApi } from './api/index.ts'

export { fieldApi }
export default fieldApi.reducer
